/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {useEffect} from 'react';
import moment from 'moment-timezone';

const useSystemTimezone = () => {
  useEffect(() => {
    const previousTimezone = moment.tz.guess(true);
    const systemTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    moment.tz.setDefault(systemTimezone);

    return () => {
      moment.tz.setDefault(previousTimezone);
    };
  }, []);
};

export default useSystemTimezone;
